// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"SliderOfferSection_cardContainer__3nyq9","sliderContainer":"SliderOfferSection_sliderContainer__3LeTc","nextButton":"SliderOfferSection_nextButton__3TcwA"};